import React from 'react'
import {Container,CartContent} from 'components'

export default function CartPage(){
  return <Container><CartContent/></Container>
}